import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import './ProposalLaySelection.scss';
import ButtonBase from '../../components/Buttons/ButtonBase';
import { withStyles } from '@material-ui/core/styles';

import {
  cleanProposalData,
  loadProposalData,
  setProposalSelected,
} from '../../store/actions/ProposalsAction';

const styles = () => ({
  expandButton: {
    display: 'flex',
    color: '#013957',
    cursor: 'pointer',
  },
  ButtonBase: {
    padding: 0,
    margin: 0,
    width: 144,
    minWidth: 'initial',
  },
  linkStyle: {
    width: 144,
    margin: '0 10px 0 0',
    '&:last-child': {
      margin: 0,
    },
  },
});

const ProposalLaySelection = (props) => {
  const {
    classes,
    activar,
    elements,
    boton,
    setStep,
    setCreateView,
    cleanProposalData,
    loadProposalData,
    proposalData,
    valuesToEdit,
    handleSubmit,
  } = props;

  // useEffect(() => {

  // }, [boton])

  const handleCancel = (event) => {
    cleanProposalData();
    setCreateView(false);
    window.scroll(0, 0);
  };

  // const onSubmit = (event) => {
  //   if(valuesToEdit && Object.values(valuesToEdit).length > 0) {
  //     console.log('edit')
  //     const newProposalData = {
  //       ...valuesToEdit,
  //       templateId: boton.id,
  //     };
  //     setProposalSelected(newProposalData);
  //   } else {
  //     console.log('create')
  //     const newProposalData = {
  //       ...proposalData,
  //       templateId: boton.id,
  //     };
  //     loadProposalData(newProposalData);
  //   }
  //   window.scroll(0, 0);
  //   setStep(1);
  // };

  return (
    <div className="PLS">
      <div>
        <p className="PLS-subtitle">Plantillas predeterminadas</p>
      </div>
      <div className="PLS-containerThemes">
        {elements.map((item, index) => (
          <div
            key={item.id}
            className="PLS-containerCards"
            onClick={() => {
              activar(item.id);
            }}
          >
            <div
              className="PLS-containerCards_card"
              style={{ backgroundImage: `url(${item.pathImg}) ` }}
            >
              <div
                className={
                  item.id === (boton && boton.id)
                    ? 'PLS-aprobacion_activo'
                    : 'PLS-aprobacion_inactivo'
                }
              />
            </div>
            <div className="PLS-containerCards_text">{item.name}</div>
          </div>
        ))}
      </div>

      <div className="PLS-containerBtns">
        <hr className="PLS-separator" />
        <div>
          <ButtonBase
            type="submit"
            onClick={handleSubmit}
            variant="primary"
            linkStyle={classes.linkStyle}
            className={classes.ButtonBase}
            style={{ marginRight: 16 }}
          >
            Elegir
          </ButtonBase>

          <ButtonBase
            type="submit"
            onClick={handleCancel}
            variant="primarySolidOutlined"
            linkStyle={classes.linkStyle}
            className={classes.ButtonBase}
          >
            Cancelar
          </ButtonBase>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  proposalData: state.proposalsReducer.newProposalData,
  valuesToEdit: state.proposalsReducer.selectedProposal,
});

const mapDispatchToProps = (dispatch) => ({
  cleanProposalData: () => dispatch(cleanProposalData()),
  loadProposalData: (proposalData) => dispatch(loadProposalData(proposalData)),
  setProposalSelected: (proposalData) =>
    dispatch(setProposalSelected(proposalData)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(ProposalLaySelection));
